import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { isAdminEmail } from './lib/admin';
import { useAuth } from './lib/auth';
import { AdminPage } from './pages/AdminPage';
import { AuthPage } from './pages/AuthPage';
import { CreatePage } from './pages/CreatePage';
import { FeedPage } from './pages/FeedPage';
import { ShowsPage } from './pages/ShowsPage';
import { VotePage } from './pages/VotePage';

function AdminRoute() {
  const { loading, user } = useAuth();
  if (loading) return <div className="page-pad">Loading...</div>;
  if (!isAdminEmail(user?.email)) return <Navigate to="/feed" replace />;
  return <AdminPage />;
}

export default function App() {
  return (
    <Router>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/feed" replace />} />
          <Route path="/feed" element={<FeedPage />} />
          <Route path="/shows" element={<ShowsPage />} />
          <Route path="/shows/:seriesId" element={<ShowsPage />} />
          <Route path="/create" element={<CreatePage />} />
          <Route path="/vote" element={<VotePage />} />
          <Route path="/admin" element={<AdminRoute />} />
          <Route path="/login" element={<AuthPage />} />
          <Route path="*" element={<Navigate to="/feed" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}
